import { Component, OnInit } from '@angular/core';
import { MenuState } from 'src/app/state/menu.state';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { ColumnaTabla } from 'src/app/models/Tabla';
import { GestionarAdministradoresService } from 'src/app/service/gestion/gestionar-administradores.service';
import { GestionarDistribuidoresService } from 'src/app/service/gestion/gestionar-distribuidores.service';
import { IGenericResponse } from 'src/app/models/IGenericResponse';
import { IFormulario } from 'src/app/models/Formulario';
import { FormulariosState } from 'src/app/state/formularios.state';
import { NotificationService } from 'src/app/service/notificaciones.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-gestion',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.css']
})

export class GestionComponent implements OnInit {

  opciones_menu: MenuItem[] = [];
  opcion_seleccionada: string | null = '';
  lista: any[] = [];
  columnas: ColumnaTabla[] = [];
  ver_dialog: boolean = false;
  formulario: IFormulario[] = [];
  datos_formulario: any[]=[];
  id_seleccionado: number = 0;
  items: MenuItem[] = [];

  constructor(private menuState: MenuState, private route: ActivatedRoute, 
              private formulariosState: FormulariosState,
              private GestionarAdministradoresService: GestionarAdministradoresService,
              private GestionarDistribuidoresService: GestionarDistribuidoresService,
              private NotificationService: NotificationService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.opcion_seleccionada = params.get('opcion');
      this.opciones_menu = this.menuState.items_menu;
      if (this.opcion_seleccionada) this.cargarParametrosTabla(this.opcion_seleccionada);
    });
    this.items = this.menuState.items_opciones;
  }
              
  private cargarParametrosTabla(opcion: string): void {
    const configuracion = this.obtenerConfiguracionPorOpcion(opcion);
    if (configuracion) {
      configuracion.servicio().subscribe((response: IGenericResponse) => {
        this.lista = response.data;
        this.columnas = configuracion.columnas;
        this.formulario = configuracion.formulario;
      });
    } 
    else this.NotificationService.notificacionError("Error al cargar los parametros de la tabla!"); 
  }
              
  private obtenerConfiguracionPorOpcion(opcion: string): {
    servicio: () => Observable<IGenericResponse>;
    columnas: any;
    formulario: any;
  } | null {
    switch (opcion) {
      case 'administradores':
        return {
          servicio: this.GestionarAdministradoresService.getAdministradores.bind(this.GestionarAdministradoresService),
          columnas: this.menuState.columnas_administradores,
          formulario: this.formulariosState.formulario_editar_administrador,
        };
      case 'distribuidores':
        return {
          servicio: this.GestionarDistribuidoresService.getDistribuidores.bind(this.GestionarDistribuidoresService),
          columnas: this.menuState.columnas_distribuidores,
          formulario: this.formulariosState.formulario_editar_distribuidor,
        };
      default:
        return null;
    }
  }
              
  editar(rowData: any) {
    this.ver_dialog = true;
    this.datos_formulario = rowData;
    this.id_seleccionado = rowData.id;
  }
  onRecibirFormulario(event: any){
    event.id = this.id_seleccionado;
    this.actualizar(event);
  }
  actualizar(datos: any) {
    if(this.opcion_seleccionada != null){
      const servicio = this.obtenerServicioPorOpcion(this.opcion_seleccionada);
      if (servicio) this.editarEntidad(servicio, datos);
    } 
  }
  
  private obtenerServicioPorOpcion(opcion: string): any {
    switch (opcion) {
      case 'administradores':
        return this.GestionarAdministradoresService.editarAdministrador.bind(this.GestionarAdministradoresService);
      case 'distribuidores':
        return this.GestionarDistribuidoresService.editarDistribuidor.bind(this.GestionarDistribuidoresService);
      default:
        return null;
    }
  }
  
  private editarEntidad(servicio: (datos: any) => Observable<IGenericResponse>, datos: any): void {
    servicio(datos).subscribe((response: IGenericResponse) => {
      if (response.error === "") this.NotificationService.notificacionSuccess("Editado correctamente.");
      else this.NotificationService.notificacionError("Error al editar.");
      this.ver_dialog = false;
      this.lista = response.data;
    });
  }
}
